import { render } from "./ListPosts.vue?vue&type=template&id=2b58cca1&scoped=true"
import script from "./ListPosts.vue?vue&type=script&lang=js"
export * from "./ListPosts.vue?vue&type=script&lang=js"

import "./ListPosts.vue?vue&type=style&index=0&id=2b58cca1&scoped=true&lang=css"

import exportComponent from "H:\\Productions\\CS\\inc\\helpers\\cs-restaurants\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b58cca1"]])

export default __exports__